module.exports = __webpack_public_path__ + "static/media/giftBox.db650947.png";